module.exports = {
  breadcrumb_navigation: 'Pfadnavigation',
  skip_to_content: 'Zum Hauptinhalt springen',
  search: 'Suchen',
  modal: 'Dialogfenster',
  go_to_previous_slide: 'Zur vorherigen Folie',
  go_to_next_slide: 'Zur nächsten Folie',
  toggle_contents_list: 'Inhaltsverzeichnis umschalten',
  sidenav: {
    label: 'Hauptnavigation',
  },
  back: 'Zurück',
  configure_notifications: 'Benachrichtigungen konfigurieren',
  correct: 'Richtig',
  date_until: 'Bis %{date}',
  days_left: 'Noch 1 Tag|Noch %{days} Tage',
  ending_today: 'Nur noch heute',
  forename: 'Vorname',
  powerlearning: 'Powerlearning',
  learningmaterials: 'Mediathek',
  tests: 'Tests',
  courses: 'Kurse',
  lastname: 'Nachname',
  loading: 'Laden',
  mail: 'E-Mail',
  member: 'Mitglied | Mitglieder',
  multiple_choice: 'Multiple Choice',
  not_found_404: 'Diese Seite wurde leider nicht gefunden',
  notifications_title: 'Benachrichtigungen konfigurieren',
  notifications_confirm: 'Bitte bestätige die Nachfrage des Browsers',
  notification_successful_body: 'Du erhältst eine Benachrichtigung wenn du an der Reihe bist',
  notification_successful_title: 'Benachrichtigungen aktiviert',
  x_months_from_start: '%{x} Monat ab Start | %{x} Monate ab Start',
  x_weeks_from_start: '%{x} Woche ab Start | %{x} Wochen ab Start',
  x_days_from_start: '%{x} Tag ab Start | %{x} Tage ab Start',
  optional: '(optional)',
  typingIndicator: {
    usersTyping: '{count} User schreibt | {count} User schreiben',
  },
  minutes: '1 Minute | %{n} Minuten',
  x_days_left: 'Noch 1 Tag | Noch %{days} Tage',
  access_denied: 'Zugriff verweigert',
  offline_message: 'Diese Funktion steht dir zur Verfügung sobald du wieder online bist.',
  ad: 'Anzeige',
  want_more_explanation: 'Hilf dabei, den Wissensschatz in deinem Unternehmen aufzubauen und das Quiz und Powerlearning zu erweitern.',
  abort: 'Abbrechen',
  click_again_to_stop_recording: 'Klicke erneut, um die Aufnahme zu stoppen',
  set_filters: 'Filter anwenden',
  show_more: 'Mehr anzeigen',
  show_less: 'Weniger anzeigen',
  show_more_text_label: 'Mehr Text anzeigen',
  show_all: 'Zeige mir alle',
  no_audio_support: 'Dein Browser unterstützt das Audio Element nicht.',
  hi_name: 'Hi %{name}.',
  required: 'Pflichtfeld',
  suggest_question: {
    category_label: 'Kategorie',
    couldnt_suggest_question: 'Die Frage konnte leider nicht eingereicht werden',
    cant_load_suggestion_categories: 'Es konnten leider nicht alle nötigen Daten geladen werden. Bitte versuche es später erneut.',
    question_label: 'Frage',
    correct_answer_label: 'Richtige Antwort',
    wrong_answer_x_label: 'Falsche Antwort %{x}',
    suggest_new_question: 'Neue Frage vorschlagen',
    submit_question: 'Frage einreichen',
    question_suggested_successfully: 'Vielen Dank! Wir prüfen deine Frage in Kürze.',
    answers_explanation: 'Bitte gib eine richtige und drei falsche Antworten für deine Frage ein.',
  },
  to_home: 'Zur Startseite',
  what_do_you_want_to_learn_today: 'Was möchtest du heute lernen?',
  voucher_code: 'Voucher-Code',
  next: 'Weiter',
  new_content: 'Neue Inhalte',
  from: 'Ab',
  download: 'Herunterladen',
  open_link: 'Link öffnen',
  missing_module_title: 'Leider hast du auf diesen Inhalt keinen Zugriff.',
  available: 'Verfügbar',
  want_notifications: 'Möchtest du benachrichtigt werden wenn du wieder an der Reihe bist?',
  filter_title: 'Filter',
  filter: 'Filter:',
  dofilter: 'Filtern:',
  self: 'Ich',
  userAvatar: 'Benutzerbild',
  previous: 'Zurück',
  back_to_home: 'Zurück zur Startseite',
  back_to_overview: 'Zurück zur Übersicht',
  retry: 'Erneut versuchen',
  starts_at_date: 'Startet am %{date}',
  close: 'Schließen',
  wrong: 'Falsch',
  enter_query_to_start_search: 'Gib einen Suchbegriff ein um mit der Suche zu starten.',
  player: 'Spieler | Spieler',
  started_at_date: 'Gestartet %{date}',
  question_preview_unavailable: 'Diese Frage kann leider nicht angezeigt werden.',
  filter_unseen: 'Ungesehen',
  new: 'Neu',
  no_results_for_filters: 'Keine Einträge für die gewählten Filter',
  no_search_results: 'Keine Ergebnisse für deine Suche',
  not_available_anymore: 'Nicht mehr verfügbar',
  realname: 'Realname',
  user_search_placeholder: 'Name oder E-Mail...',
  username: 'Benutzername',
  user_search_placeholder_wo_email: 'Name...',
  offline: 'Offline',
  online: 'Online',
  page_x_of_y: 'Seite %{currentPage} von %{totalPages}',
  page_x: 'Seite %{page}',
  password: 'Passwort',
  current_password_placeholder: 'Dein aktuelles Passwort',
  current_password: 'Bestehendes Passwort',
  pause: 'Pause',
  app_by_keeunit: 'Powered by <a href="https://www.keelearning.de" target="_blank">keeunit GmbH</a>',
  question_preview: 'Fragenvorschau',
  total_progress: 'Gesamtfortschritt',
  quiz_battle: 'Quiz-Battle',
  reply: 'Antworten',
  play: 'Abspielen',
  results: 'Ergebnis | Ergebnisse',
  save: 'Speichern',
  or: 'oder',
  updating: 'Aktualisiere...',
  settings_saved: 'Die Einstellungen wurden erfolgreich gespeichert.',
  sort: 'Sortieren',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  reset_search_filters: 'Alle Filter löschen',
  you_are_offline: 'Du bist offline. Einige Funktionen sind nur verfügbar, wenn du online bist.',
  file_type: 'Dateityp',
  filter_all: 'Alle',
  submit: 'Absenden',
  last_learned: 'Zuletzt gelernt',
  confirm_password: 'Bitte bestätige die Änderung durch Eingabe deines Passworts',
  missing_module_description: 'Bitte wende dich an deinen Administrator um Zugriff zu erhalten.',
  please_choose: 'Bitte wählen',
  see_whats_new: 'Sieh dir an, was es Neues gibt:',
  filter_seen: 'Gesehen',
  want_more: 'Du hast Lust auf mehr?',
  webinars: 'Webinare',
}
